import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { userAccountIdSelector } from 'selectors/user/user-features-selector';
import { getStoredHeaderPins, subscribeHeaderPins } from '../header-pins';
import type { HeaderPins, HeaderPinsUserId } from '../header-pins';

/** React 17–compatible external store subscription (useSyncExternalStore is React 18+). */
export const useStoredHeaderPins = (): HeaderPins | null => {
    const userId: HeaderPinsUserId = useSelector(userAccountIdSelector);
    const [headerPins, setHeaderPins] = useState(() => getStoredHeaderPins(userId));

    // A different user (e.g. after re-login) has their own pins
    useEffect(() => {
        setHeaderPins(getStoredHeaderPins(userId));

        return subscribeHeaderPins(setHeaderPins, userId);
    }, [userId]);

    return headerPins;
};
